export default [
	{
		name: 'NOMEATESTANTEPRIMARIO',
		value: 'Nome do médico',
	},
	{
		name: 'NOMEDECLARANTE',
		value: 'Nome da parte'
	},
	{
		name: 'FLAGDESCONHECIDO' ,     
		value: 'Indicador Desconhecido'
	},
	{
		name: 'NOMEFALECIDO' , 
		value: 'Nome do Falecido'
	}, 
	{
		name: 'NOMEREGISTRADO' , 
		value: 'Nome do Registrado'
	}, 
	{
		name: 'CPFFALECIDO' , 
		value: 'CPF do Falecido'
	}, 
	{
		name: 'MATRICULA' , 
		value: 'Matricula'
	}, 
	{
		name: 'DATAREGISTRO' , 
		value: 'Data do Registro'
	}, 
	{
		name: 'DATA_REGISTRO',
		value: 'Data do Registro'
	},
	{
		name: 'NOMEPAI' , 
		value: 'Nome do Pai'
	}, 
	{
		name: 'CPFPAI' , 
		value: 'CPF do Pai'
	}, 
	{
		name: 'SEXOPAI' , 
		value: 'Sexo do Pai'
	}, 
	{
		name: 'NOMEMAE' , 
		value: 'Nome da Mãe'
	}, 
	{
		name: 'CPFMAE' , 
		value: 'CPF da Mãe'
	}, 
	{
		name: 'SEXOMAE' , 
		value: 'Sexo da Mãe'
	}, 
	{
		name: 'DATAOBITO' , 
		value: 'Data do óbito'
	}, 
	{
		name: 'HORAOBITO' , 
		value: 'Hora do óbito'
	}, 
	{
		name: 'SEXO' , 
		value: 'Sexo'
	}, 
	{
		name: 'CORPELE' , 
		value: 'Cor da Pele'
	}, 
	{
		name: 'ESTADOCIVIL' , 
		value: 'Estado Civil'
	}, 
	{
		name: 'DATANASCIMENTOFALECIDO' , 
		value: 'Data de Nascimento do Falecido'
	}, 
	{
		name: 'IDADE' , 
		value: 'Idade'
	}, 
	{
		name: 'IDADE_DIAS_MESES_ANOS' , 
		value: 'Tempo Nascido'
	}, 
	{
		name: 'ELEITOR' , 
		value: 'Eleitor'
	}, 
	{
		name: 'POSSUIBENS' , 
		value: 'Possui Bens'
	}, 
	{
		name: 'CODIGOOCUPACAOSDC' , 
		value: 'Codigo ocupação'
	}, 
	{
		name: 'PAISNASCIMENTO' , 
		value: 'País do Nascimento'
	}, 
	{
		name: 'NACIONALIDADE' , 
		value: 'Nacionalidade'
	}, 
	{
		name: 'CODIGOIBGEMUNNATURALIDADE' , 
		value: 'Código IBGE Naturalidade'
	}, 
	{
		name: 'TEXTOLIVREMUNICIPIONAT' , 
		value: 'Texto Municipio Naturalidade'
	}, 
	{
		name: 'DOMICILIOESTRANGEIROFALECIDO' , 
		value: 'Domicílio Estrangeiro'
	}, 
	{
		name: 'CODIGOIBGEMUNLOGRADOURO' , 
		value: 'Código IBGE Logradouro'
	}, 
	{
		name: 'LOGRADOURO' , 
		value: 'Logradouro'
	}, 
	{
		name: 'NUMEROLOGRADOURO' , 
		value: 'Número Logradouro'
	}, 
	{
		name: 'COMPLEMENTOLOGRADOURO' , 
		value: 'Complemento Logradouro'
	}, 
	{
		name: 'BAIRRO' , 
		value: 'Bairro'
	}, 
	{
		name: 'BENEFICIOS_PREVIDENCIARIOS' , 
		value: 'Benefícios Previdenciários'
	}, 
	{
		name: 'INDICEREGISTRO' , 
		value: 'Indíce do Registro'
	}, 
	{
		name: 'NUMEROBENEFICIO' , 
		value: 'Número do Beneficio'
	}, 
	{
		name: 'DOCUMENTOS' , 
		value: 'Documentos'
	}, 
	{
		name: 'DONO' , 
		value: 'Dono'
	}, 
	{
		name: 'TIPO_DOC' , 
		value: 'Tipo de Documento'
	}, 
	{
		name: 'DESCRICAO' , 
		value: 'Descricao'
	}, 
	{
		name: 'NUMERO' , 
		value: 'Número do documento'
	}, 
	{
		name: 'NUMERO_SERIE' , 
		value: 'Número de série do documento'
	}, 
	{
		name: 'CODIGOORGAOEMISSOR' , 
		value: 'Código Orgão Emissor'
	}, 
	{
		name: 'UF_EMISSAO' , 
		value: 'UF Emissor'
	}, 
	{
		name: 'DATA_EMISSAO' , 
		value: 'Data de Emissão'
	}, 
	{
		name: 'TIPOLOCALOBITO' , 
		value: 'Tipo de Local de Obito'
	}, 
	{
		name: 'TIPOMORTE' , 
		value: 'Tipo de Morte'
	}, 
	{
		name: 'NUMDECLARACAOOBITO' , 
		value: 'Número de Declaração de Óbito'
	}, 
	{
		name: 'NUMDECLARACAOOBITOIGNORADA' , 
		value: 'Número de Declaração de Óbito Ignorada'
	}, 
	{
		name: 'PAISOBITO' , 
		value: 'País do Óbito'
	}, 
	{
		name: 'CODIGOIBGEMUNLOGRADOUROOBITO' , 
		value: 'Código IBGE Municipio Logradouro Óbito'
	}, 
	{
		name: 'ENDERECOLOCALOBITOESTRANGEIRO' , 
		value: 'Endereço Local do Óbito Estrangeiro'
	}, 
	{
		name: 'LOGRADOUROOBITO' , 
		value: 'Logradouro Óbito'
	}, 
	{
		name: 'NUMEROLOGRADOUROOBITO' , 
		value: 'Número Logradouro Óbito'
	}, 
	{
		name: 'COMPLEMENTOLOGRADOUROOBITO' , 
		value: 'Complen'
	}, 
	{
		name: 'BAIRROOBITO' , 
		value: 'Bairro do Óbito'
	}, 
	{
		name: 'CAUSAMORTEANTECEDENTES_A' , 
		value: 'Causa da Morte Antecedente A'
	}, 
	{
		name: 'CAUSAMORTEANTECEDENTES_B' , 
		value: 'Causa da Morte Antecedente B'
	}, 
	{
		name: 'CAUSAMORTEANTECEDENTES_C' , 
		value: 'Causa da Morte Antecedente C'
	}, 
	{
		name: 'CAUSAMORTEANTECEDENTES_D' , 
		value: 'Causa da Morte Antecedente D'
	}, 
	{
		name: 'CAUSAMORTEOUTRASCOND_A' , 
		value: 'Causa da Morte Outras Condições A'
	}, 
	{
		name: 'CAUSAMORTEOUTRASCOND_B' , 
		value: 'Causa da Morte Outras Condições C'
	}, 
	{
		name: 'LUGARFALECIMENTO' , 
		value: 'Lugar do Falecimento'
	}, 
	{
		name: 'LUGARSEPULTAMENTOCEMITERIO' , 
		value: 'Lugar do Sepultamento'
	}, 
	{
		name: 'CRMATESTANTEPRIMARIO' , 
		value: 'CRM Médico'
	}, 
	{
		name: 'NOMEATESTANTESECUNDARIO' , 
		value: 'Nome do Segundo Médico'
	}, 
	{
		name: 'CRMATESTANTESECUNDARIO' , 
		value: 'CRM do Segundo Médico'
	}, 
	{
		name: 'CPFDECLARANTE' , 
		value: 'CPF da Parte'
	}, 
	{
		name: 'ORGAOEMISSOREXTERIOR' , 
		value: 'Orgão Emissor Exterior'
	}, 
	{
		name: 'INFORMACOESCONSULADO' , 
		value: 'Informações do Consulado'
	}, 
	{
		name: 'OBSERVACOES' , 
		value: 'Observações'
	}, 
	{
		name: 'DATAAVERBACAO',
		value: 'Data de averbação'
	}
]		
